import { Container } from "@mui/material";
import Accordion from "../../components/Accordion";
import SectionTitle from "../../components/SectionTitle";
import { FAQS } from "../../constants";

const FaqSection = () => {
  return (
    <section id="faq">
      <Container>
        <SectionTitle title="FAQ"></SectionTitle>
        <Accordion items={FAQS}></Accordion>
      </Container>
    </section>
  );
};

export default FaqSection;
